import { app } from '../../app';
import { Controller } from './language-switcher.controller';

app.component('languageSwitcher', {
    controller: Controller,
    templateUrl: require('./language-switcher.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/language-switcher/language-switcher.component.js